<template>
  <div class="tab-wrap">
    <div
      class="tab-item"
      :class="{'selected':value === index}"
      v-for="(item,index) in tabItems"
      :key="item.value || item"
      @click="onTabItemClick(index)"
    >{{item.value || item}}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tabItems: Array,
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {

  },
  methods: {
    onTabItemClick(index) {
      if (this.value === index) return; // 点击项相同将不做任何操作
      this.$emit('input',index)
      this.$emit("on-change", index);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.tab-wrap {
  display: flex;
  align-items: center;
}
.tab-item {
  color: #999;
  font-size: 14px;
  padding: 8px 10px;
  background-color: #fff;
  cursor: pointer;
  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}
.selected {
  background-color: #ff7d44;
  color: #fff;
}
</style>